<template>
  <div id="horseFilterList" class="mb-3">
    <div id="filter-toggle" class="toggle-filters d-block d-md-none"><a @click="toggleFilters()" class="btn btn-primary">Open Search Filters</a></div>

    <div id="search-filters-wrapper" class="search-filters">
      <div class="mt-3 mt-md-0 mb-3">
        <label class="form-label" for="keyword">Search</label>
        <input type="text" v-model="searchKeywordFilter" id="keyword" class="form-control" />
      </div>

      <fieldset class="horse-filter-wrapper sex-list-wrapper" v-if="sexOptions && sexOptions.length">
        <legend>Filter By Sex</legend>
        <div class="sex-options options-wrapper">
          <div v-for="(option) in sexOptions" :key="option" class="option">
            <label>
              <input type="checkbox" v-model="searchSexFilter" :value="option" />
              {{ option }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="horse-filter-wrapper age-list-wrapper" v-if="ageMin !== ageMax">
        <legend>Filter By Age</legend>
        <div class="age-options options-wrapper">
          <Slider
            v-model="ageValues"
            :min="ageMin"
            :max="ageMax"
            showTooltip="drag"
            :format="ageFilterCaption"
            @change="updateAgeValues"
          />
        </div>
      </fieldset>

      <fieldset class="horse-filter-wrapper color-list-wrapper" v-if="colorOptions && colorOptions.length">
        <legend>Filter By Color</legend>
        <div class="type-options options-wrapper">
          <div v-for="(option) in colorOptions" :key="option" class="option">
            <label>
              <input type="checkbox" v-model="searchColorFilter" :value="option.replace('/', '--')" />
              {{ option }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="horse-filter-wrapper pattern-list-wrapper" v-if="patternOptions && patternOptions.length">
        <legend>Filter By Pattern</legend>
        <div class="pattern-options options-wrapper">
          <div v-for="(option) in patternOptions" :key="option" class="option">
            <label>
              <input type="checkbox" v-model="searchPatternFilter" :value="option" />
              {{ option }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="horse-filter-wrapper height-list-wrapper" v-if="heightMin !== heightMax">
        <legend>Filter By Height</legend>
        <div class="height-options options-wrapper">
          <Slider
            v-model="heightValues"
            :min="heightMin"
            :max="heightMax"
            showTooltip="drag"
            :format="heightFilterCaption"
            @change="updateHeightValues"
          />
        </div>
      </fieldset>

      <fieldset class="horse-filter-wrapper price-list-wrapper" v-if="priceMin !== priceMax">
        <legend>Filter By Price</legend>
        <div class="height-options options-wrapper">
          <Slider
            v-model="priceValues"
            :min="priceMin"
            :max="priceMax"
            showTooltip="drag"
            :format="priceFilterCaption"
            @change="updatePriceValues"
          />
        </div>
      </fieldset>

      <fieldset class="horse-filter-wrapper registry-list-wrapper" v-if="registryOptions && registryOptions.length">
        <legend>Filter By Registry</legend>
        <div class="registry-options options-wrapper">
          <div v-for="(option) in registryOptions" :key="option" class="option">
            <label>
              <input type="checkbox" v-model="searchRegistryFilter" :value="option" />
              {{ option }}
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { useModelWrapper } from '@/utils/modelWrapper'
// https://github.com/vueform/slider
import Slider from '@vueform/slider'

export default {
  name: 'SearchFilters',
  components: {
    Slider
  },
  props: {
    keywordFilter: String,
    sexFilter: Array,
    ageFilterMin: Number,
    ageFilterMax: Number,
    colorFilter: Array,
    patternFilter: Array,
    heightFilterMin: Number,
    heightFilterMax: Number,
    priceFilterMin: Number,
    priceFilterMax: Number,
    registryFilter: Array,
    sexOptions: Array,
    ageMin: Number,
    ageMax: Number,
    colorOptions: Array,
    patternOptions: Array,
    heightMin: Number,
    heightMax: Number,
    priceMin: Number,
    priceMax: Number,
    registryOptions: Array
  },
  data: () => ({
    ageFilterCaption: function (value) {
      if (value === 0) {
        return 'Foal/Weanling'
      } else {
        return value
      }
    },
    heightFilterCaption: function (value) {
      if (value === 40) {
        return '40+'
      } else {
        return `${Math.round(value)}"`
      }
    },
    priceFilterCaption: function (value) {
      if (value === 0) {
        return 'Call For Price'
      } else {
        return `$${Math.round(value)}`
      }
    }
  }),
  setup (props, { emit }) {
    return {
      searchKeywordFilter: useModelWrapper(props, emit, 'keywordFilter'),
      searchSexFilter: useModelWrapper(props, emit, 'sexFilter'),
      searchAgeFilterMin: useModelWrapper(props, emit, 'ageFilterMin'),
      searchAgeFilterMax: useModelWrapper(props, emit, 'ageFilterMax'),
      searchColorFilter: useModelWrapper(props, emit, 'colorFilter'),
      searchPatternFilter: useModelWrapper(props, emit, 'patternFilter'),
      searchHeightFilterMin: useModelWrapper(props, emit, 'heightFilterMin'),
      searchHeightFilterMax: useModelWrapper(props, emit, 'heightFilterMax'),
      searchPriceFilterMin: useModelWrapper(props, emit, 'priceFilterMin'),
      searchPriceFilterMax: useModelWrapper(props, emit, 'priceFilterMax'),
      searchRegistryFilter: useModelWrapper(props, emit, 'registryFilter')
    }
  },
  computed: {
    ageValues () {
      return [this.searchAgeFilterMin, this.searchAgeFilterMax]
    },
    heightValues () {
      return [this.searchHeightFilterMin, this.searchHeightFilterMax]
    },
    priceValues () {
      return [this.searchPriceFilterMin, this.searchPriceFilterMax]
    }
  },
  methods: {
    toggleFilters: function () {
      var button = document.getElementById('filter-toggle').getElementsByClassName('btn-primary')[0]
      var filters = document.getElementById('search-filters-wrapper')
      if (button.innerHTML === 'Open Search Filters') {
        button.innerHTML = 'Close Search Filters'
        filters.style.height = filters.scrollHeight + 'px'
      } else {
        button.innerHTML = 'Open Search Filters'
        filters.style.height = '0px'
      }
    },
    updateAgeValues (values) {
      this.searchAgeFilterMin = values[0]
      this.searchAgeFilterMax = values[1]
    },
    updateHeightValues (values) {
      this.searchHeightFilterMin = values[0]
      this.searchHeightFilterMax = values[1]
    },
    updatePriceValues (values) {
      this.searchPriceFilterMin = values[0]
      this.searchPriceFilterMax = values[1]
    }
  }
}
</script>

<style src="@vueform/slider/themes/default.css"></style>
